export const SYSTEM_USER_BULK_UPLOAD_TEST_IDS = {
    pageRoot: 'system-user-bulk-upload-page',
    uploadPageRoot: 'system-user-bulk-upload-upload-step',
    reviewPageRoot: 'system-user-bulk-upload-review-step',
    executingPageRoot: 'system-user-bulk-upload-executing-step',
    resultsPageRoot: 'system-user-bulk-upload-results-step',
    workbookInput: 'system-user-bulk-upload-workbook-input',
    reviewSummaryCards: 'system-user-bulk-upload-review-summary-cards',
    reviewSummaryRows: 'system-user-bulk-upload-review-summary-rows',
    reviewSummaryUsers: 'system-user-bulk-upload-review-summary-users',
    reviewSummaryGroups: 'system-user-bulk-upload-review-summary-groups',
    reviewSummaryTeams: 'system-user-bulk-upload-review-summary-teams',
    reviewSummaryInvites: 'system-user-bulk-upload-review-summary-invites',
    reviewSummaryBlockingErrors: 'system-user-bulk-upload-review-summary-blocking-errors',
    invalidUsersSection: 'system-user-bulk-upload-invalid-users-section',
    executeButton: 'system-user-bulk-upload-execute-button',
    executeDialog: 'system-user-bulk-upload-execute-dialog',
    executingFileCard: 'system-user-bulk-upload-executing-file-card',
    resultsSummaryCards: 'system-user-bulk-upload-results-summary-cards',
    resultsTotalImpact: 'system-user-bulk-upload-results-total-impact',
    resultsUsersCreated: 'system-user-bulk-upload-results-users-created',
    resultsUsersUpdated: 'system-user-bulk-upload-results-users-updated',
    resultsGroupsCreated: 'system-user-bulk-upload-results-groups-created',
    resultsTeamsCreated: 'system-user-bulk-upload-results-teams-created',
    resultsInvitesSent: 'system-user-bulk-upload-results-invites-sent',
    resultsActions: 'system-user-bulk-upload-results-actions',
} as const;
